import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "2 1.5 14 15.25"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.89304 1.50191C7.39892 1.55419 6.15768 2.71673 6.01428 4.20067C5.98498 4.49745 6.00194 4.78502 6.05437 5.06027C6.05437 5.06027 6.05899 5.09257 6.07441 5.15408C6.12067 5.36014 6.19006 5.56004 6.2764 5.74765C6.57708 6.45809 7.27248 7.64678 8.8329 8.94003C8.9285 9.01999 9.06882 9.01999 9.16596 8.94003C10.7264 7.64831 11.4218 6.45963 11.724 5.74611C11.8119 5.55851 11.8797 5.36014 11.926 5.15254C11.9399 5.09257 11.946 5.05874 11.946 5.05874C11.9815 4.8742 12 4.68506 12 4.4913C12 2.80285 10.5984 1.44194 8.89304 1.50191ZM9 5.625C9.62132 5.625 10.125 5.12132 10.125 4.5C10.125 3.87868 9.62132 3.375 9 3.375C8.37868 3.375 7.875 3.87868 7.875 4.5C7.875 5.12132 8.37868 5.625 9 5.625Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M13.875 6.75H4.125L3 15.75H15L13.875 6.75Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linejoin": "round",
  fill: "none"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M4.5 11.1964L14.25 12.9643M13.875 7.875L7.5 15.75",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}